/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function farmPreferences(instance) {
	return {
		/**
		 * @param {number} farmId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (farmId, config = {}) => {
			return instance.get(`retailers/farm_preferences/${farmId}`, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(`retailers/farm_preferences${params}`, config)
		},

		/**
		 * @param {number} farmId
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		edit: (farmId, body, config = {}) => {
			return instance.put(`retailers/farm_preferences/${farmId}`, body, config)
		},

		/**
		 * @param {number} farmId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (farmId, config = {}) => {
			return instance.delete(`retailers/farm_preferences/${farmId}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('retailers/farm_preferences', body, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllByRetailerId: (retailerId, pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(
				`retailers/${retailerId}/farm_preferences${params}`,
				config
			)
		}
	}
}
